import { render, staticRenderFns } from "./Ptsppemda.vue?vue&type=template&id=afaac6b4"
import script from "./Ptsppemda.vue?vue&type=script&lang=js"
export * from "./Ptsppemda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports